module.exports = __webpack_public_path__ + "static/media/note-5-color.a5dcb02d.svg";